import { render, staticRenderFns } from "./student_detail.vue?vue&type=template&id=2e34ddfd&"
import script from "./student_detail.vue?vue&type=script&lang=js&"
export * from "./student_detail.vue?vue&type=script&lang=js&"
import style0 from "./student_detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports